module.exports = __webpack_public_path__ + "img/biaoqian_huojing.9e380dde.png";